export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('table_label_storeName') || '商铺名称',
    field: 'storeName',
    align: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_postedDateTime') || '结算时间',
    field: 'postedDateTime',
    align: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_transactionType') || '业务类型',
    field: 'transactionType',
    align: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amountType') || '金额类型',
    field: 'amountType',
    align: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amountDescription') || '金额描述',
    field: 'amountDescription',
    headerAlign: 'center',
    align: 'left',
    minWidth: 260,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_amount') || '金额',
    field: 'amount',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_quantity') || '数量',
    field: 'quantity',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderId') || '订单ID',
    field: 'orderId',
    align: 'center',
    minWidth: 220,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sku_ecom') || 'SKU',
    field: 'sku_ecom',
    align: 'center',
    minWidth: 180,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displaySku') || 'SKU描述',
    field: 'displaySku',
    headerAlign: 'center',
    align: 'left',
    minWidth: 240,
    showHeaderOverflow: true,
    slots: { default: 'displaySku' },
  },
  {
    title: that.$l('table_label_displaySpu') || 'SPU描述',
    field: 'displaySpu',
    headerAlign: 'center',
    align: 'left',
    minWidth: 240,
    showHeaderOverflow: true,
    slots: { default: 'displaySpu' },
  },
  {
    title: that.$l('table_label_itemPrice') || '产品金额',
    field: 'itemPrice',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_itemShipping') || '产品运费',
    field: 'itemShipping',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_commission') || '产品佣金',
    field: 'commission',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_promotion') || '产品促销',
    field: 'promotion',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_points') || '产品积分',
    field: 'points',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fbaPerUnitFulfillmentFee') || 'FBA运费',
    field: 'fbaPerUnitFulfillmentFee',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_itemPriceSum') || '价格小计',
    field: 'itemPriceSum',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_itemFeeSum') || '费用小计',
    field: 'itemFeeSum',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_itemWithheldTax') || '税费小计',
    field: 'itemWithheldTax',
    align: 'center',
    minWidth: 130,
    isTotalColumn: true,
    showHeaderOverflow: true,
  },
]
